<template>
  <div>
    <!-- Cart Steps -->
    <cart-steps step="customer" />

    <osv-app-alert osv-alert-position="osv-alert-relative" />

    <!-- If I have item in my basket -->
    <div v-if="cartItems.length > 0">

      <!-- If customer is logged in -->
      <div v-if="this.isLoggedIn">
        <use-account :error-report="errorReport" />
      </div>

      <!-- If customer is not logged in -->
      <div v-if="!this.isLoggedIn">
        <cart-create-customer
          :error-report="errorReport"
          :show-commercial-offer="commercialOffer"
          :show-newsletter="newsletter"
          :additional-required-fields="additionalRequiredFields"
        />
      </div>
    </div>

    <!-- If I my basket is empty -->
    <div v-if="cartItems.length === 0">
      <p class="text-grey text-center">
        <cite>
          ...
        </cite>
      </p>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CartSteps from "./partial/cart/CartSteps";
import UseAccount from "./partial/cart/customer/UseAccount";
import CartCreateCustomer from "./partial/cart/customer/CreateCustomer";
import OsvAppAlert from "@/components/shared/OsvAppAlert";
import {CustomisationMixin} from "@/mixins/CustomisationMixin";

export default {
  store,
  name: "CartCustomer",
  mixins: [CustomisationMixin],
  components: { OsvAppAlert, CartCreateCustomer, UseAccount, CartSteps },

  props: {
    hideCommercialOffer: {
      type: Boolean,
      default: false
    },

    hideNewsletter: {
      type: Boolean,
      default: false
    },

    requiredFields: {
      type: String,
      default: null
    },

    // TODO : Delete after widget-options depreciation
    widgetOptions: {
      type: String,
      default: null
    }
  },

  computed: {
    isLoggedIn () {
      return store.getters["auth/isLoggedIn"];
    },

    cartItems () {
      return store.getters["cart/getItems"];
    },

    additionalRequiredFields () {
      if (this.customisation && this.customisation.additionalRequiredFields !== undefined) {
        return this.customisation.additionalRequiredFields.split(',');
      } else if (this.requiredFields !== null) {
        return this.requiredFields.split(',');
      } else {
        return []
      }
    },

    commercialOffer () {
      if (this.customisation && this.customisation.commercialOffer !== undefined) {
        return this.customisation.commercialOffer;
      } else {
        return !this.hideCommercialOffer;
      }
    },

    newsletter () {
      if (this.customisation && this.customisation.newsletter !== undefined) {
        return this.customisation.newsletter;
      } else if (this.hideNewsletter === true) {
        return !this.hideNewsletter;
      } else {
        return true;
      }
    }
  },

  methods: {
    errorReport (err) {
      // Clear cart if is not "normal" error
      if (err.response.status !== 422) store.dispatch("cart/clearCart");

      // Display error message
      this.$root.$emit("OsvAlert_ErrorFromApi", err, "cart");
    }
  }
};
</script>

<style lang="scss" src="../assets/styles/buefy/base.scss"></style>
